import React, { Component } from 'react';
import skip_logic_map from '../assets/json/diseases-skip-logic-map.json';
const keys_mapping = skip_logic_map.thyroid

class SkipLogicThyroidView extends Component {

  getValue(key) {
    if(!(key in keys_mapping)) return null

    let code = keys_mapping[key]
    let data = this.props.skipLogics.find(item => item.skip_logic_code == code)

    if(typeof(data) === 'undefined') return null
    return data.answer
  }  

  render() {
    let sl = this.props.skipLogics;
    if(sl == null) return null;
    let medullary = this.getValue('medullary');    
    let papillary = this.getValue('papillary');    

    return (
      <React.Fragment >
        <p>
          {medullary == "y" && 'Medullary'}
        </p>
        <p>
          {papillary == "y" && 'Papillary (cribiform-morular variant)'}
        </p>
      </React.Fragment>
    )
  }

}

export default SkipLogicThyroidView